module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"card":"Карта","of_foreign_bank":"иностранного банка"},"en":{"card":"Card","of_foreign_bank":"of foreign bank"}}')
  delete Component.options._Ctor
}
